export default "__VITE_ASSET__52594bbf__"